import { useRoute } from './lib/router';
import { AuthorView } from './views/AuthorView';
import { Home } from './views/Home';
import { ClipView } from './views/ClipView';
import { ModeratorView } from './views/ModeratorView';
import { PlaybackView } from './views/PlaybackView';
import { ProjectionView } from './views/ProjectionView';

export function App() {
  const route = useRoute();
  switch (route.view) {
    case 'mod':
      return <ModeratorView pin={route.pin} />;
    case 'write':
      return <AuthorView pin={route.pin} />;
    case 'beam':
      return <ProjectionView pin={route.pin} />;
    case 'play':
      return <PlaybackView />;
    case 'clip':
      return <ClipView />;
    default:
      return <Home />;
  }
}
